import base from "@/store/utils/api-route/base";

const epaymentAPI = {
	list: {
		transaksi: `${base.meta}list_riwayat_pemakaian_epayment_v2`,
		paket: `${base.meta}list_epayment`,
		paketTiny: `${base.meta}list_epayment_tiny`,
		topup: `${base.meta}list_topup_epayment`,
	},
	info: `${base.meta}rincian_topup_epayment`,
	detail: `${base.meta}detail_pembelian_epayment`,
	refund: `${base.pembatalan}refund_pembelian_epayment`,
	refundV2: `${base.pembatalan}refund_pembelian_epayment_v2`,
	permintaanHapus: `${base.pembatalan}setujui_permintaan_hapus_epayment_v2`,
	export: {
		job: `${base.export}job`,
		track: `${base.export}track_redis_job`,
		delete: {
			cluster: `${base.export}delete_cluster_redis_job`,
			master: `${base.export}delete_master_redis_job`,
		},
	}
}

export default epaymentAPI